import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

/**
 * Prefixes all requests not starting with `http[s]` with `environment.serverUrl`.
 */
@Injectable({
  providedIn: 'root',
})
export class ApiPrefixInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (
      !/^(http|https):/i.test(request.url) &&
      request.url.indexOf(environment.assetsUrl) === -1 &&
      request.url.indexOf('oauth') === -1
    ) {
      request = request.clone({ url: `${environment.serverUrl}${request.url}` });
    }

    if (!/^(http|https):/i.test(request.url) && request.url.indexOf('oauth') > -1) {
      request = request.clone({ url: environment.authUrl + request.url });
    }

    return next.handle(request);
  }
}
